import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import GraphqlErrorMixin from '@/helpers/vue_mixins/GraphqlErrorMixin';
import RouteParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import AppAdministratorsQuery from '@/plugins/graphql/queries/app-administrators.gql';
let CachedAppAdministratorsMixin = class CachedAppAdministratorsMixin extends mixins(RouteParamsAppMixin, GraphqlErrorMixin) {
    fetchCachedAppAdmin(store) {
        let data = null;
        try {
            data = store.readQuery({
                query: AppAdministratorsQuery,
                variables: {
                    appUUID: this.appUUID,
                },
            });
        }
        catch (error) {
            this.logError(error);
        }
        return data;
    }
};
CachedAppAdministratorsMixin = __decorate([
    Component
], CachedAppAdministratorsMixin);
export default CachedAppAdministratorsMixin;
